<app-navbar [title]="pageTitle">
	<button class="btn btn-warning me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="deleteAsk()">
		Usuń
	</button>
	<button
		class="btn btn-primary me-3"
		*ngIf="(pageFunction === 'edit' && editable) || pageFunction === 'add'"
		(click)="submit()"
	>
		Zapisz
	</button>
	<button class="btn btn-primary me-3" *ngIf="pageFunction === 'edit' && !editable" (click)="editUnlock()">
		Edycja
	</button>
	<a routerLink="../" class="btn btn-danger"> <i class="fas fa-chevron-left"></i> Powrót </a>
</app-navbar>

<div class="container my-4">
	<ul class="nav nav-tabs" id="myTab" role="tablist">
		<li class="nav-item" role="presentation">
			<a class="nav-link active" id="general-tab" data-bs-toggle="tab" href="#general" role="tab">Podstawowe</a>
		</li>
		<li class="nav-item" role="presentation">
			<a class="nav-link" id="groups-tab" data-bs-toggle="tab" href="#groups" role="tab">Grupy</a>
		</li>
	</ul>
	<form (submit)="submit()">
		<div class="tab-content my-4" id="myTabContent">
			<fieldset
				[disabled]="pageFunction !== 'add' && !editable"
				class="tab-pane fade active show"
				id="general"
				role="tabpanel"
			>
				<div class="form-floating mb-3">
					<input
						type="text"
						class="form-control"
						id="firstName"
						name="firstName"
						[(ngModel)]="data.firstName"
						placeholder="Imię"
						required
					/>
					<label for="firstName">Imię</label>
				</div>
				<div class="form-floating mb-3">
					<input
						type="text"
						class="form-control"
						id="lastName"
						name="lastName"
						[(ngModel)]="data.lastName"
						placeholder="Nazwisko"
						required
					/>
					<label for="lastName">Nazwisko</label>
				</div>
				<div class="form-floating mb-3">
					<input
						type="email"
						class="form-control"
						id="email"
						name="email"
						[(ngModel)]="data.email"
						placeholder="E-mail"
						required
					/>
					<label for="email">E-mail</label>
				</div>
			</fieldset>
			<fieldset
				[disabled]="pageFunction !== 'add' && !editable"
				class="tab-pane fade"
				id="groups"
				role="tabpanel"
			>
				<app-checkboxes [items]="parameters.groups" [(values)]="data.groups"></app-checkboxes>
			</fieldset>
		</div>
	</form>
</div>
